import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CluesPage from "@/pages/clues/page";
import ClueDetailPage from "@/pages/clueDetail/page";
import CategoriesPage from "@/pages/categories/page";
import CategoryDetailPage from "@/pages/categoryDetail/page";
import SubmitPage from "@/pages/submit/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "clues", element: <CluesPage /> },
      { path: "clue/:slug", element: <ClueDetailPage /> },
      { path: "categories", element: <CategoriesPage /> },
      { path: "category/:slug", element: <CategoryDetailPage /> },
      { path: "submit", element: <SubmitPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;